<template>
  <div id="Review">
    <div v-for="u in uebungen" :key="u">
      <div class="uebungButton pointer">
        <button>
          {{ u }}
        </button>
      </div>
      <div class="uebungInfo">
        <div
          v-for="(f, index) in me[u]"
          :key="f"
          @click="selectFeedback(u, index)"
          :class="[
            feedbackSelected.f == index && feedbackSelected.u == u
              ? 'selected'
              : '',
            calcScoreRAW(f.data) >= highest[u] ? 'highest' : '',
            calcScoreRAW(f.data) <= lowest[u] ? 'lowest' : '',
          ]"
        >
          {{ index }} : {{ calcScore(f.data) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Review",
  components: {},
  props: {
    me: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    me: function (newV) {
      this.generateHighLow(newV);
    },
  },
  data() {
    return {
      uebungen: ["A", "B", "C", "D"],
      feedbackSelected: {
        u: "",
        f: "",
      },
      highest: {},
      lowest: {},
    };
  },

  methods: {
    reset() {
      this.feedbackSelected = {
        u: "",
        f: "",
      };
    },
    generateHighLow(me) {
      //prefill high and low
      for (const u of this.uebungen) {
        this.highest[u] = 0;
        this.lowest[u] = 100;
      }
      console.log(this.highest);
      console.log(this.lowest);

      for (const u in me) {
        if (u == "score" || u == "winner" || u == "nameAlt") continue;
        console.log(u);
        for (const f in me[u]) {
          let s = this.calcScoreRAW(me[u][f].data);
          if (s > this.highest[u]) {
            this.highest[u] = s;
          }
          if (s < this.lowest[u]) {
            this.lowest[u] = s;
          }
        }
      }
    },
    selectFeedback(u, f) {
      if (this.feedbackSelected.u == u && this.feedbackSelected.f == f) {
        this.feedbackSelected.u = "";
        this.feedbackSelected.f = "";
        return;
      }
      this.feedbackSelected.u = u;
      this.feedbackSelected.f = f;

      this.$emit("review", this.feedbackSelected);
    },
    calcScoreRAW(feedback) {
      // console.log(feedback);
      let s = 0;
      for (const f of feedback) {
        s += f;
      }
      if (s <= 0) return 0;
      s = s / (feedback.length * 10);
      return s;
    },
    calcScore(feedback) {
      // console.log(feedback);
      let s = 0;
      for (const f of feedback) {
        s += f;
      }
      if (s <= 0) return this.scoreFilter(0);
      s = (s / (feedback.length * 10)) * 100;
      s = Math.round(s * 10) / 10;
      return this.scoreFilter(s);
    },
    scoreFilter(n) {
      if (n == 0) return "--,-";
      let s = parseFloat(n).toLocaleString("de-DE");
      if (!String(s).includes(",")) {
        return s + ",0";
      }
      return s;
    },
  },
  created() {
    this.generateHighLow(this.me);
  },
};
</script>

<style scoped>
.highest {
  border: 2px solid var(--lightgreen) !important;
}

.lowest {
  border: 2px solid var(--doblhoferRed) !important;
}

.uebungInfo {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  /* overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none; */
  justify-content: flex-end;
}

.uebungInfo > div {
  margin: 6px;
  /* flex: 1 1 65px; */
  text-align: center;
  padding: 6px;
  border: 2px solid black;
  border-radius: 6px;
  max-height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 75px;
  font-size: 1.15em;
}

.uebungInfo::-webkit-scrollbar {
  display: none; /* for Chrome, Safari, and Opera */
}

#Review {
  display: inline-block;
  /* height: calc(100vh - 150px - min(7vw, 41px) - min(11vw, 44px) - 50px); */
  height: calc(100vh - 170px);
  overflow: scroll;
  width: 100%;
}

#Review > div {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-top: 1px dashed #626262;
}

.selected {
  background: red !important;
}

.uebungButton {
  margin: 10px 0px;
}

.uebungButton > button {
  width: 40px;
  height: 40px;
  text-align: center;
  font-size: 30px;
  border-radius: 6px;
  background: white;
  border: 2px solid var(--green);
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: var(--green);
  color: white;
}

@media screen and (max-height: 640px) {
  #Review {
    height: calc(100vh - 150px);
  }
}
</style>
